import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import BASE_URL from "../config";
import SidebarRFQ from "../POpage/SidebarRFQ";
import Select from "react-select";

const CloneRFQ = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [file1, setFile1] = useState(null);
  const [clients, setClients] = useState([]);
  const [suppiler, setSupplier] = useState([]);
  const user = JSON.parse(localStorage.getItem("userdata"));

  const [formData, setFormData] = useState({
    rfq_number: "",
    rfq_date: "",
    client_name: "",
    client_contact: "",
    client_email: "",
    closing_date: "",
    products: "",
    status: "",
    bid_status: "",
    quote_submit_date: "",
    assigned_staff: "",
    client_feedback: "",
    manufacturer_supplier: "",
    if_lost: "",
    status_feedback: "",
    latest_update: "",
    rfq_attachment: "",
  });

  useEffect(() => {
    fetchClients();
    fetchSupplier();
    if (id) fetchRFQData(id);
  }, [id]);

  const fetchClients = () => {
    axios
      .get(`${BASE_URL}/api/client-get`)
      .then((res) => setClients(res.data))
      .catch((err) => console.error("Error fetching clients:", err));
  };

  const fetchSupplier = () => {
    axios
      .get(`${BASE_URL}/api/supplier-get`)
      .then((res) => setSupplier(res.data))
      .catch((err) => console.error("Error fetching suppliers:", err));
  };

  const fetchRFQData = async (id) => {
  try {
    const res = await axios.get(`${BASE_URL}/api/get-rfq-data/${id}`);
    const data = res.data;

    // Set all form fields
    setFormData({
      rfq_number: data.rfq_number || "",
      rfq_date: data.rfq_date || "",
      client_name: data.client_name || "",
      client_contact: data.client_contact || "",
      client_email: data.client_email || "",
      closing_date: data.closing_date || "",
      products: data.products || "",
      status: data.status || "",
      bid_status: data.bid_status || "",
      quote_submit_date: data.quote_submit_date || "",
      assigned_staff: data.assigned_staff || "",
      client_feedback: data.client_feedback || "",
      manufacturer_supplier: data.manufacturer_supplier || "",
      if_lost: data.if_lost || "",
      status_feedback: data.status_feedback || "",
      latest_update: data.latest_update || "",
      rfq_attachment: data.rfq_attachment || "",
    });

    // Save the existing file path for preview
    setFile1(data.rfq_attachment || "");

  } catch (err) {
    console.error("Error fetching RFQ data:", err);
  }
};


  const handleChangecreate = (e) => {
    const { name, value } = e.target;
    if (name === 'manufacturer_supplier' && value === 'add_new') {
      navigate('/supplier');
      return;
    }
    if (name === 'client_name' && value === 'add_new') {
      navigate('/clientadd');
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

 const handleSubmit = async () => {
  const sendData = new FormData();

  // Append all form fields except rfq_attachment
   Object.entries(formData).forEach(([key, value]) => {
    
      sendData.append(key, value);
    
  });

    sendData.append("old_file", formData.rfq_attachment);

  // ✅ Only append if a new file was selected
  if (file1 instanceof File) {
    sendData.append("rfq_attachment", file1);
  }

  try {
    const res = await axios.post(`${BASE_URL}/api/craeterfqdata`, sendData, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
    handleSubmitCreateRFQ()

    Swal.fire("Success", res.data.message || "RFQ submitted successfully", "success");
    navigate("/listrfq");
  } catch (err) {
    console.error("Submit error:", err);
    Swal.fire("Error", err.response?.data?.message || "Submission failed", "error");
  }
};


 const handleSubmitCreateRFQ = async () => {
      try {
        const response = await axios.post('https://bimanager.nexteck.uk/api/messages', 
          {
            user_id:user.id,
            type:"RFQ",
            message:"New RFQ Clone Created",
            status:"0"
          }
        );
        console.log(response.data);
      
      } catch (error) {
        console.error(error);
       
      }
    };

  return (
    <div className="row">
     <div className="custom-2-5">

              <SidebarRFQ />
              </div>
      <div className="custom-9-5 dashboardsclooer p-4">
        <div className="card p-4 mt-1 shadow" style={{ backgroundColor: "#fff" }}>
          <h5 className="mb-3">CLONE RFQ</h5>

          <div className="row mt-4 p-3">
 <div className="form-group mb-3 col-lg-4">
  <label><strong>RFQ Attachment</strong></label><br />

  <input
    type="file"
    accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.png"
    onChange={(e) => setFile1(e.target.files[0])} // Replaces file1 if new selected
  />
  <input type="hidden" name ="old_file" value={formData.rfq_attachment}/>

  {/* Show View Link if existing file and not changed */}
  {formData.rfq_attachment && (
    <a
      href={`${BASE_URL}/public/${formData.rfq_attachment}`}
      target="_blank"
      rel="noopener noreferrer"
      className="btn btn-sm btn-outline-primary mt-2"
    >
      View Current File
    </a>
  )}
</div>




            {[
              { label: "RFQ Number*", name: "rfq_number" },
              { label: "RFQ Received Date*", name: "rfq_date", type: "date" },
            ].map(({ label, name, type = "text" }) => (
              <div className="form-group mb-3 col-lg-4" key={name}>
                <label>
                  <strong>{label}</strong>
                </label>
                <input
                  type={type}
                  name={name}
                  className="form-control"
                  value={formData[name]}
                  onChange={handleChangecreate}
                />
              </div>
            ))}

            {/* <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Client Name*</strong>
              </label>
              <select
                name="client_name"
                className="form-control"
                value={formData.client_name}
                onChange={handleChangecreate}
              >
                <option value="">Select Client</option>
                {clients.map((client, index) => (
                  <option key={index} value={client.client_name}>
                    {client.client_name}
                  </option>
                ))}

                <option value="add_new">
                  
                  <button className="btn btn-primary">New Add</button>
               
                </option>
              </select>
            </div>

             <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Manufacturer/Supplier</strong>
              </label>
              <select
                name="manufacturer_supplier"
                className="form-control"
                value={formData.manufacturer_supplier}
                onChange={handleChangecreate}
              >
                <option value="">Select Supplier</option>
                {suppiler.map((client, index) => (
                  <option key={index} value={client.name}>
                    {client.name}
                  </option>
                ))}
                <option value="add_new">
                  
                  <button className="btn btn-primary">New Add</button>
               
                </option>
              </select>
       
            </div> */}

            <div className="form-group mb-3 col-lg-4">
  <label>
    <strong>Client Name *</strong>
  </label>
  <Select
    name="client_name"
    options={[
      ...clients.map((c) => ({
        label: c.client_name,
        value: c.client_name,
      })),
      { label: "➕ Add New Client", value: "add_new" },
    ]}
    value={
      formData.client_name
        ? { label: formData.client_name, value: formData.client_name }
        : null
    }
    onChange={(selected) => {
      if (!selected) return;
      const value = selected.value;

      if (value === "add_new") {
        navigate("/clientadd");
        return;
      }

      setFormData((prev) => ({ ...prev, client_name: value }));
    }}
    placeholder="Select Client"
    isSearchable
    classNamePrefix="react-select"
  />
</div>

{/* <div className="form-group mb-3 col-lg-4">
  <label>
    <strong>Manufacturer/Supplier</strong>
  </label>
  <Select
    name="manufacturer_supplier"
    options={[
      ...suppiler.map((s) => ({
        label: s.name,
        value: s.name,
      })),
      { label: "➕ Add New Supplier", value: "add_new" },
    ]}
    value={
      formData.manufacturer_supplier
        ? {
            label: formData.manufacturer_supplier,
            value: formData.manufacturer_supplier,
          }
        : null
    }
    onChange={(selected) => {
      if (!selected) return;
      const value = selected.value;

      if (value === "add_new") {
        navigate("/supplier");
        return;
      }

      setFormData((prev) => ({ ...prev, manufacturer_supplier: value }));
    }}
    placeholder="Select Supplier"
    isSearchable
    classNamePrefix="react-select"
  />
</div> */}


            {[
              { label: "Manufacturer/Supplier", name: "manufacturer_supplier" },
              { label: "Client Contact", name: "client_contact" },
              { label: "Client Email", name: "client_email" },
              {
                label: "RFQ Closing Date*",
                name: "closing_date",
                type: "date",
              },
              { label: "Products/Number of Icon", name: "products" },
              {
                label: "Quote Submit Date",
                name: "quote_submit_date",
                type: "date",
              },
              // { label: "Manufacturer/Supplier", name: "manufacturer_supplier" },
              { label: "Assigned Staff", name: "assigned_staff" },
              { label: "Latest Update", name: "latest_update" },
              { label: "Client Feedback", name: "client_feedback" },
            ].map(({ label, name, type = "text" }) => (
              <div className="form-group mb-3 col-lg-4" key={name}>
                <label>
                  <strong>{label}</strong>
                </label>
                <input
                  type={type}
                  name={name}
                  className="form-control"
                  value={formData[name]}
                  onChange={handleChangecreate}
                />
              </div>
            ))}

            {/* Dropdowns */}
            <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Status</strong>
              </label>
              <select
                name="status"
                className="form-control"
                value={formData.status}
                onChange={handleChangecreate}
              >
                <option value="">Select</option>
                <option>RFQ Sent</option>
                <option>Supplier Quote received</option>
                <option>Quote submitted to Client</option>
                <option>Quote not Received From Supplier</option>
                <option>Under clarification</option>
              </select>
            </div>
            {formData.status && (
              <div className="form-group mb-3 col-lg-4">
                <label>
                  <strong>Current Remark</strong>
                </label>
                <input
                  type="text"
                  name="status_feedback"
                  className="form-control"
                  value={formData.status_feedback || ""}
                  onChange={handleChangecreate}
                />
              </div>
            )}

            <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Bid Status</strong>
              </label>
              <select
                name="bid_status"
                className="form-control"
                value={formData.bid_status}
                onChange={handleChangecreate}
              >
                <option value="">Select</option>
                <option>Won</option>
                <option>Lost</option>
                <option>Onhold</option>
                <option>In-Progress</option>
              </select>
            </div>

            <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>If Lost</strong>
              </label>
              <select
                name="if_lost"
                className="form-control"
                value={formData.if_lost}
                onChange={handleChangecreate}
              >
                <option value="">Select</option>
                <option>Price</option>
                <option>Technical</option>
                <option>Other</option>
              </select>
            </div>
          </div>
          <div className="text-center">
            <button className="btn btncolor w-50 mt-2" onClick={handleSubmit}>
              Submit RFQ
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloneRFQ;


